import { client } from './client'
import Fund from '../models/fund'

export default {
  index (query) {
    return client.get('/funds', {
      params: query
    })
  },
  show (id) {
    return client.get('/funds/' + id)
      .then((response) => {
        return new Fund(false, response.data.data)
      })
  },
  reels (id, query) {
    return client.get('/funds/' + id + '/reels', {
      params: query
    })
  },
  store (data) {
    return client.post('/funds', data.prepareForSend())
  },
  update (id, data) {
    return client.patch('/funds/' + id, data.prepareForSend())
  },
  saveArchiveWeb (id) {
    return client.get('/funds-save-archive-web/' + id)
  },
  delete (id) {
    return client.delete('/funds/' + id)
  },
  search (data, query) {
    return client.get('/funds', {
      params: {
        filter: JSON.stringify(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    })
  },
  select (data) {
    let fund = new Fund()
    fund.denominazione = data
    return client.get('/funds?include=reels', {
      params: {
        filter: JSON.stringify(fund),
        limit: 100,
        orderBy: 'denominazione'
      }
    })
  },
  deleteImage (fundId, imageId) {
    return client.delete('/funds/' + fundId + '/fundimage/' + imageId)
  },
  export (type, data) {
    client.defaults.responseType = 'blob'
    return client.get('/funds-export/' + type, {
      params: {
        ids: data
      }
    }).then((response) => {
      client.defaults.responseType = 'json'
      return response
    })
  },
  refreshContents () {
    return client.post('/refresh-contents')
  }
}



// WEBPACK FOOTER //
// ./src/api/funds.js